import { render } from "./RHome.vue?vue&type=template&id=715757d3"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/RHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "715757d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('715757d3', __exports__)) {
    api.reload('715757d3', __exports__)
  }
  
  module.hot.accept("./RHome.vue?vue&type=template&id=715757d3", () => {
    api.rerender('715757d3', render)
  })

}


export default __exports__